import { Type } from 'class-transformer';
import { OrdinaryObject } from 'src/modules/utils/shared/ordinary-object.model';
import { EnaioInboxProcessDto } from './enaio-inbox-process-dto.model';
import { FrontendWorkflowInboxDefinition } from './frontend-workflow-inbox-definition.model';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';

export class EnaioInboxDto {

    @Type(() => EnaioInboxProcessDto)
    processes: EnaioInboxProcessDto[];
    processToInboxMapping: OrdinaryObject<string>;
    @Type(() => FrontendWorkflowInboxDefinition)
    inboxes: FrontendWorkflowInboxDefinition[];

    translate(app: MainAppService): void {
        for (let inbox of this.inboxes) {
            inbox.title = app.t("wfs.inboxes." + inbox.id + ".title", null, inbox.title);
            for (let col of inbox.columns) {
                col.title = app.t("wfs.inboxes." + inbox.id + ".columns." + col.id, null, col.title);
            }
        }
    }
}
